const staticContent = [
  'wöchentlich',
  'einmal im Monat',
  'alle zwei Monate',
  '2x im Jahr',
  'jährlich'
];
module.exports = staticContent;
